// O que aparece no menu na V1 (docs/produto/v1-escopo.md). As telas escondidas continuam no código
// e abrem pela URL; para liberar, tire a rota daqui.
export const ESCONDIDAS_NA_V1 = ["/painel", "/clientes", "/vendas", "/compras", "/analises"] as const;

export function escondidaNaV1(href: string): boolean {
  return (ESCONDIDAS_NA_V1 as readonly string[]).includes(href);
}
